import React from 'react';
import Header from './Header/Header';
import Display from './Display/Display';

function Main() {

    return (
        <>
            <Header />
            <Display />
        </>
    )
}

export default Main